
import Main from "../Main/DataAnalysis";
import Header from "../header/Header";

const DataAnalysis = () => {
    return (

        <div className="App">
            <Header />
            <Main course={"data-analysis"} />
        </div>
    )
}

export default DataAnalysis;